import moment from "moment";
import "moment-timezone";

// Generate options array
export const generateTimezoneOptions = () => {
  const allTimezones = moment.tz.names();

  // Filter timezones with whole hour offsets
  const filteredTimezones = allTimezones.filter(isWholeHourOffset);

  // Map to options with offset
  const timezoneOptions = filteredTimezones.map((tz) => {
    const offsetInMinutes = moment.tz(tz).utcOffset();
    const offsetInHours = offsetInMinutes / 60;
    const sign = offsetInHours >= 0 ? "+" : "-";
    const offsetFormatted = `GMT${sign}${Math.abs(offsetInHours)}`;

    return {
      id: tz, // e.g., "Europe/Sofia" ✅
      name: `${offsetFormatted} (${tz})`, // e.g., "GMT+3 (Europe/Sofia)" ✅
    };
  });

  // Remove duplicates (if any) and sort the options
  const uniqueOptions = Array.from(
    new Map(timezoneOptions.map((item) => [item.name, item])).values()
  ).sort((a, b) => {
    const offsetA = parseInt(a.name.replace("GMT", ""));
    const offsetB = parseInt(b.name.replace("GMT", ""));
    return offsetA - offsetB;
  });

  return uniqueOptions;
};

const isWholeHourOffset = (timezone: string) => {
  const offsetInMinutes = moment.tz(timezone).utcOffset();
  return offsetInMinutes % 60 === 0;
};
